import { Button, Form, Input, message, Row } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import { UploadFile } from 'antd/lib/upload/interface'
import React, { useEffect, useState } from 'react'
import { Problem } from '../Model'
import KnowledgeFormUpload from '../../../knowledge-management/knowledge/uploads/KnowledgeFormUpload'
import { updateProblem, updatePTaskById } from '../service'
import FSS from '../../../file-server-storage'
import { UploadLink } from '../../../file-server-storage/model'

interface params {
    id?: string
    visible?: boolean
    problem?: Problem
    setClosed?: Function
    reloadData?: Function
    isRenderPTask?: boolean
}
type Props = params & FormComponentProps
const ModalEditTitle: React.FC<Props> = (props: Props) => {
    const { getFieldDecorator, setFieldsValue } = props.form
    const [fileList, setFileList] = useState<UploadFile[]>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (props.problem) {
            setFieldsValue({
                Label: props.problem?.topic,
                Description: props.problem?.description
            })
            const uploadFile = props.problem.pbUpload?.map((file) => {
                const uploadFile: UploadFile = {
                    uid: file.name,
                    name: file.name,
                    status: 'done',
                    url: file.url,
                    type: file.type,
                    size: 0
                }
                return uploadFile
            })
            setFileList(uploadFile || [])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.problem, props.visible])

    const handleSubmit = (e) => {
        e.preventDefault()
        props.form.validateFields(async (err: any, values) => {
            if (!err) {
                if (props.id && props.problem) {
                    setIsLoading(true)
                    const convertData: any = {
                        // ...props.problem,
                        topic: values.Label,
                        description: values.Description
                    }
                    if (fileList.length > 0 && fileList.length <= 5) {
                        FSS.putFile(fileList, 'problem', (uploadLink: UploadLink[]) => {
                            convertData.pbUpload = uploadLink?.map((data) => {
                                return {
                                    name: data.name,
                                    url: data.url,
                                    type: data.type
                                } as UploadLink
                            })
                            submitEditData(convertData)
                        })
                    } else if (fileList.length > 5) {
                        message.error('Upload File Max 5')
                        setIsLoading(false)
                    } else {
                        submitEditData(convertData)
                    }
                }
            }
        })
    }

    const closeModal = () => {
        if (props.setClosed) {
            props.setClosed(false)
        }
    }

    const validateTopicAndDes = (_rule: any, value: any, callback) => {
        if (value) {
            const CheckValue = value.replace(/ +/g, '').trim()
            if (CheckValue.length >= 3) {
                callback()
            } else {
                callback('Enter more than 3 characters')
            }
        } else {
            callback()
        }
    }

    const submitEditData = (convertData) => {
        if (props.isRenderPTask) {
            updatePTaskById(props.id!!, convertData).then(() => {
                message.success('The update has finished successfully.')
                if (props.setClosed && props.reloadData) {
                    props.setClosed(false)
                    props.reloadData(true)
                }
            }).finally(() => { setIsLoading(false) })
        } else {
            updateProblem(props.id!!, convertData).then(() => {
                message.success('The update has finished successfully.')
                if (props.setClosed && props.reloadData) {
                    props.setClosed(false)
                    props.reloadData(true)
                }
            }).finally(() => { setIsLoading(false) })
        }
    }

    return (
        <div>
            <Form>
                <Form.Item label={'Topic'} className='custom-formLabel-wo'>
                    {getFieldDecorator('Label', {
                        initialValue: props.problem?.topic,
                        rules: [{ required: true, message: 'Please input Topic' }, { whitespace: true }, { validator: validateTopicAndDes }]
                    })(
                        <Input placeholder='label' />
                    )}
                </Form.Item>
                <Form.Item label={'Description'} className='custom-formLabel-wo'>
                    {getFieldDecorator('Description', {
                        initialValue: props.problem?.description,
                        rules: [{ required: true, message: 'Please input Description' }, { whitespace: true }, { validator: validateTopicAndDes }]
                    })(
                        <Input.TextArea rows={4} placeholder='Description' />
                    )}
                </Form.Item>
                <Row>
                    <KnowledgeFormUpload fileList={fileList} setFileList={(fileList: UploadFile[]) => { setFileList(fileList) }} />
                </Row>

                <br />
                <hr />
                <Form.Item style={{ textAlign: 'end' }}>
                    <Button htmlType="button" style={{ marginRight: 10 }} onClick={() => closeModal()}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" onClick={handleSubmit} loading={isLoading}>
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

const ModalEditTitleForm = Form.create<Props>()(ModalEditTitle)
export default ModalEditTitleForm
